// QUANTDELTA Terminal/Matrix Design System
export const theme = {
  colors: {
    // Primary terminal green
    primary: '#00ff41', // Bright neon green
    primaryDark: '#00cc33',
    primaryLight: '#33ff66',
    
    // Background
    bg: '#000000', // Pure black
    bgSecondary: '#0a0a0a', // Slightly lighter black
    bgTertiary: '#1a1a1a', // Dark gray for cards
    
    // Text
    text: '#00ff41', // Neon green text
    textSecondary: '#00cc33', // Darker green for secondary text
    textMuted: '#00ff4180', // Semi-transparent green
    textDark: '#003311', // Very dark green for contrast
    
    // Accents
    accent: '#00ffff', // Cyan for highlights
    accentPurple: '#9d4edd', // Purple for special elements
    warning: '#ffaa00', // Orange/yellow for warnings
    error: '#ff0040', // Red for errors
    success: '#00ff41', // Green for success
    
    // Borders
    border: '#00ff4140', // Semi-transparent green borders
    borderBright: '#00ff41', // Bright green borders
    
    // Overlays
    overlay: 'rgba(0, 0, 0, 0.8)',
    overlayLight: 'rgba(0, 255, 65, 0.1)',
  },
  
  fonts: {
    mono: '"Courier New", "Monaco", "Menlo", "Ubuntu Mono", monospace',
    sans: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
  },
  
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
  },
  
  shadows: {
    glow: '0 0 10px rgba(0, 255, 65, 0.5)',
    glowStrong: '0 0 20px rgba(0, 255, 65, 0.8)',
    card: '0 4px 20px rgba(0, 255, 65, 0.2)',
  },
  
  transitions: {
    fast: '0.15s ease',
    normal: '0.3s ease',
    slow: '0.5s ease',
  },
  
  // Terminal-specific styles
  terminal: {
    prompt: 'root@quantdelta~#',
    cursor: '█',
    blinkSpeed: '1s',
  },
  
  // Matrix rain characters (Japanese katakana, numbers, symbols)
  matrixChars: 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ!@#$%^&*()_+-=[]{}|;:,.<>?',
};

export default theme;

